import { APIClientError } from './api-client-error';

export type TypeCloudflareReason = 'tunnel' | 'worker' | 'unknown';

export class CloudflareError extends APIClientError {
  public readonly reason: TypeCloudflareReason;
  public readonly code?: string;

  public constructor({
    status,
    path,
    reason = 'unknown',
    code,
  }: {
    status?: number;
    path?: string;
    reason?: TypeCloudflareReason;
    code?: string;
  }) {
    super('Cloudflare error', status, undefined, path);
    this.name = 'CloudflareError';
    this.reason = reason;
    this.code = code;
  }
}
